<script setup>
import { ref, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const emit = defineEmits(['create', 'materialize']);

const { t } = useI18n();
const dialogRef = ref(null);
const mode = ref('create');

const state = reactive({
  name: '',
  description: '',
  folderName: '',
});

const rules = { name: { required } };
const v$ = useVuelidate(rules, state);

const reset = () => {
  state.name = '';
  state.description = '';
  state.folderName = '';
  v$.value.$reset();
};

const open = nextMode => {
  mode.value = nextMode;
  reset();
  dialogRef.value?.open();
};

const handleConfirm = async () => {
  if (!(await v$.value.$validate())) return;
  const payload = {
    name: state.name,
    description: state.description,
    folderName: state.folderName,
  };
  if (mode.value === 'materialize') {
    emit('materialize', payload);
  } else {
    emit('create', payload);
  }
  dialogRef.value?.close();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="
      mode === 'materialize'
        ? t('CONTACTS_LAYOUT.LISTS.SAVE_TITLE')
        : t('CONTACTS_LAYOUT.LISTS.CREATE_TITLE')
    "
    :confirm-button-label="t('CONTACTS_LAYOUT.LISTS.CONFIRM')"
    @confirm="handleConfirm"
  >
    <div class="flex flex-col gap-3">
      <Input
        v-model="state.name"
        :label="t('CONTACTS_LAYOUT.LISTS.NAME')"
        :placeholder="t('CONTACTS_LAYOUT.LISTS.NAME_PLACEHOLDER')"
        :message="v$.name.$error ? t('CONTACTS_LAYOUT.LISTS.NAME_ERROR') : ''"
        :message-type="v$.name.$error ? 'error' : 'info'"
      />
      <Input
        v-model="state.description"
        :label="t('CONTACTS_LAYOUT.LISTS.DESCRIPTION')"
        :placeholder="t('CONTACTS_LAYOUT.LISTS.DESCRIPTION_PLACEHOLDER')"
      />
      <Input
        v-model="state.folderName"
        :label="t('CONTACTS_LAYOUT.LISTS.FOLDER')"
        :placeholder="t('CONTACTS_LAYOUT.LISTS.FOLDER_PLACEHOLDER')"
      />
    </div>
  </Dialog>
</template>
